import { SafetyRecommendationCategoryIcon } from '@deckee/api-app-main';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { MarketplaceSafetyItem } from '../../../../../services/store/modules/marketplace/models';
import IconWithTextLockup from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';
import {
  anchorNew,
  bottleOfWater,
  bouy,
  bucket,
  coil,
  compass,
  dinghy,
  fireExtinguisher,
  firstAid,
  flame,
  flare,
  flashLight,
  horn,
  license,
  lifeJacket,
  map,
  paddleBoat,
  pump,
  radio,
  ReactSvg,
  spanner,
  sticker,
  ventilation,
  vSheet,
} from '../../../../shared/vector-images';
import BlueCircleWrapper from '../../../../shared/BlueCircleWrapper/BlueCircleWrapper';
import StyledNavListItem from '../StyledNavListItem/StyledNavListItem';

const getSafetyItemImage = (item: MarketplaceSafetyItem) => {
  switch (item.categoryIcon) {
    case SafetyRecommendationCategoryIcon.FireExtinguisher:
      return fireExtinguisher();
    case SafetyRecommendationCategoryIcon.Flare:
      return flare();
    case SafetyRecommendationCategoryIcon.Radio:
      return radio();
    case SafetyRecommendationCategoryIcon.Lifejacket:
      return lifeJacket();
    case SafetyRecommendationCategoryIcon.Compass:
      return compass();
    case SafetyRecommendationCategoryIcon.Killswitch:
      return coil();
    case SafetyRecommendationCategoryIcon.License:
      return license();
    case SafetyRecommendationCategoryIcon.AnchorLine:
      return anchorNew();
    case SafetyRecommendationCategoryIcon.BilgePumpBailer:
      return pump();
    case SafetyRecommendationCategoryIcon.VSheet:
      return vSheet();
    case SafetyRecommendationCategoryIcon.BottleOfWater:
      return bottleOfWater();
    case SafetyRecommendationCategoryIcon.Bucket:
      return bucket();
    case SafetyRecommendationCategoryIcon.FlashLight:
      return flashLight();
    case SafetyRecommendationCategoryIcon.PaperCharts:
      return map();
    case SafetyRecommendationCategoryIcon.SafetyChecklist:
      return sticker();
    case SafetyRecommendationCategoryIcon.SignallingDevice:
      return horn();
    case SafetyRecommendationCategoryIcon.OarOrPaddle:
      return paddleBoat();
    case SafetyRecommendationCategoryIcon.FirstAidKit:
      return firstAid();
    case SafetyRecommendationCategoryIcon.LifeRaft:
      return dinghy();
    case SafetyRecommendationCategoryIcon.LifeBouy:
      return bouy();
    case SafetyRecommendationCategoryIcon.Ventilation:
      return ventilation();
    case SafetyRecommendationCategoryIcon.BackfireFlameArrestor:
      return flame();
    case SafetyRecommendationCategoryIcon.Misc:
    default:
      return spanner();
  }
};

const SafetyGearBlock: FC<{
  item: MarketplaceSafetyItem;
  onClick: (item: MarketplaceSafetyItem) => void;
}> = ({ item, onClick }) => {
  const theme = useTheme();
  const handleClick = () => {
    onClick(item);
  };
  return (
    <StyledNavListItem chevron onClick={handleClick}>
      <IconWithTextLockup
        image={
          <BlueCircleWrapper>
            <ReactSvg
              toDisplay={getSafetyItemImage(item)}
              options={{
                fillColor: theme.colors.secondary,
              }}
              width={24}
              height={24}
            />
          </BlueCircleWrapper>
        }
        heading={item.name}
        // description={item.description}
      />
    </StyledNavListItem>
  );
};

export default SafetyGearBlock;
